import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button, Container } from '@mui/material';
import { tokens, fonts } from '../theme';

// Two overlapping squares: the old mark sliding under the new one.
export const BrandMark = ({ size = 22 }) => (
  <Box component="svg" viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" sx={{ display: 'block' }}>
    <rect x="2" y="6" width="12" height="12" rx="3" fill="none" stroke={tokens.muted} strokeWidth="2" />
    <rect x="10" y="6" width="12" height="12" rx="3" fill={tokens.accent} />
  </Box>
);

const Navbar = () => {
  const { pathname } = useLocation();
  const onUpload = pathname.startsWith('/upload');

  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        backgroundColor: 'rgba(14, 19, 32, 0.85)',
        backdropFilter: 'blur(8px)',
        borderBottom: `1px solid ${tokens.line}`,
      }}
    >
      <Container maxWidth="lg" sx={{ display: 'flex', alignItems: 'center', height: 64 }}>
        <Box
          component={RouterLink}
          to="/"
          aria-label="RepLogo home"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
            color: tokens.text,
            textDecoration: 'none',
            fontFamily: fonts.display,
            fontWeight: 700,
            fontSize: '1.2rem',
            borderRadius: 1,
            '&:focus-visible': { outline: `2px solid ${tokens.accentStrong}`, outlineOffset: 4 },
          }}
        >
          <BrandMark />
          RepLogo
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        {onUpload ? (
          <Button component={RouterLink} to="/" variant="text">
            How it works
          </Button>
        ) : (
          <Button component={RouterLink} to="/upload" variant="contained">
            Replace a logo
          </Button>
        )}
      </Container>
    </Box>
  );
};

export default Navbar;
